'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getCircularShape = undefined;

var _setup = require('./setup.js');

var _ticker = require('./ticker.js');

//added immediately after button click
var openingClass = 'is-overlaynav-opening';
//added on 'in' animation onComplete
var openClass = 'is-overlaynav-open';

//debounce btn clicks
var isOpening = false;

//has images in overlay been lazy loaded
var overlayImgsPreloaded = false;

//staggered modal items
var $imgPair = _setup.s.$navModal.find('.nx-imgpair--item');
var $streak = _setup.s.$navModal.find('.nx-imgpair--streak');
var $storeLinks = _setup.s.$navModal.find('.nx-overlay--storelinks');
var $imgLinks = _setup.s.$navModal.find('.nx--imglink-list li');
var $supportItems = _setup.s.$navModal.find('.nx-overlay--support-item');

//innner els (need min height)
var $applyto = _setup.s.$navModal.find('.nx-overlay--content');
var $measure = $applyto.find('.inner');

//create oversized circular div
var getCircularShape = exports.getCircularShape = function getCircularShape() {
	var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

	var radius = _setup.s.$window.height() > _setup.s.$window.width() ? _setup.s.$window.height() : _setup.s.$window.width();
	var circleSize = (radius * multiplier).toFixed(2) + 'px';
	return $('<div class="nx-overlay--circle" style="width:' + circleSize + ';height:' + circleSize + ';"></div>');
};

//runs @ end of showOverlayModal
var onShowFinish = function onShowFinish() {
	var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	_setup.s.$body.addClass(openClass);
	isOpening = false;
	if (cb) {
		cb();
	}
};

//Opens the Modal
var showOverlayModal = function showOverlayModal() {
	isOpening = true;

	var $circle = getCircularShape();
	_setup.s.$body.append($circle).addClass(openingClass);

	_setup.s.hideElements([$imgPair, $streak, $storeLinks, $imgLinks, $supportItems]);

	//circle swipe
	TweenMax.set($circle, { x: '-80%', y: '-80%', autoAlpha: 0 });
	TweenMax.to($circle, 0.7, { x: '-20%', y: '-20%', autoAlpha: 1, ease: Power4.easeOut, onComplete: function onComplete() {
			onShowFinish(function () {
				return $circle.remove();
			});
		} });
	//modal in
	TweenMax.to(_setup.s.$navModal, 0.2, { autoAlpha: 1, delay: 0.35 });
	//stagger contents
	TweenMax.fromTo($streak, 1.2, { scaleY: 0, autoAlpha: 0 }, { scaleY: 1, autoAlpha: 1, delay: 0.45, ease: Expo.easeOut });
	TweenMax.staggerFromTo($imgPair, 0.9, { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, delay: 0.35, ease: Expo.easeOut }, 0.15);
	TweenMax.fromTo($storeLinks, 0.9, { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, delay: 0.5, ease: Expo.easeOut });
	TweenMax.staggerFromTo($imgLinks, 0.9, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0, delay: 0.55, ease: Expo.easeOut }, 0.15);
	TweenMax.staggerFromTo($supportItems, 0.9, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0, delay: 0.65, ease: Expo.easeOut }, 0.15);

	$applyto.css({ minHeight: $measure.outerHeight() + 'px' });
};

//Closes the Modal
var hideOverlayModal = function hideOverlayModal() {
	_setup.s.$body.removeClass(openingClass + ' ' + openClass);
	TweenMax.to(_setup.s.$navModal, 0.2, { autoAlpha: 0 });
};

var lazyLoadNavimgs = function lazyLoadNavimgs() {
	if (overlayImgsPreloaded) return;
	_setup.s.$navModal.find('[data-lazy-navimg]').each(function (i, item) {
		var $this = $(item);
		var $img = $('<img>');
		$img.on('load', function () {
			return $img.addClass('is-lazyloaded');
		}).attr({ src: $this.data('lazy-navimg') });
		$this.prepend($img);
	});
	overlayImgsPreloaded = true;
};

//Button event handlers
_setup.s.$navModalToggle.on({
	//open & close
	click: function click(event) {
		event.preventDefault();
		if (isOpening) return;
		if (_setup._s.menuOverlayShowing) {
			hideOverlayModal();
			_setup._s.menuOverlayShowing = false;
			(0, _ticker.headerHandler)();
		} else {
			showOverlayModal();
			_setup._s.menuOverlayShowing = true;
		}
	}
});

if (!Modernizr.touchevents) {
	_setup.s.$navModalToggle.on('mouseenter', lazyLoadNavimgs);
} else {
	_setup.s.$window.on('nx.page.loaded', function () {
		return setTimeout(lazyLoadNavimgs, 1500);
	});
}


//////////////////
// WEBPACK FOOTER
// ./_js/menu-overlay.js
// module id = 4
// module chunks = 0